import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VTooltip from 'v-tooltip'
import "./assets/css/vtooltip.css";
Vue.use(VTooltip);

import VueToastification, { notifyRequestError } from './plugins/vueToastification.js';

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

//Declaração do axios + setLoader automático + configurações de headers
import axios from "axios";
import interceptors from "./router/interceptors";
axios.interceptors.request.use(config => interceptors(config));

global.axios = require("axios").default;
axios.interceptors.request.use(function (config) {
  store.dispatch("loader/actionSetLoader");
  return config;
});
axios.interceptors.response.use( 
  response => {
    store.dispatch("loader/actionSetLoader");
    return response;
  },
  error => {
    store.dispatch("loader/actionSetLoader");
    notifyRequestError(error);
    // sessão vencida ou inválida: volta para a tela de entrada (senha errada no login responde 422)
    if(error.response && error.response.status === 401 && localStorage.getItem("user")) {
      localStorage.removeItem("user");
      store.commit("login/SET_LOGOUT");
      router.push({name: "Login"}).catch(() => {});
    }
    return Promise.reject(error);
  }
);

Vue.directive('tooltip', VTooltip.VTooltip);
Vue.directive('close-popover', VTooltip.VClosePopover)
Vue.component('v-popover', VTooltip.VPopover)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  vuetify,
  BootstrapVue,
  IconsPlugin,
  VTooltip,
  VueToastification,
  render: h => h(App)
}).$mount('#app')
